import { format } from 'date-fns';
import { CycleData } from '@/utils/cycle-tracking';

export interface ChartDataPoint {
  day: number;
  date: string;
  phase: string;
  prediction: boolean;
  estrogen: number;
  progesterone: number;
  lh: number;
  fsh: number;
  absoluteDate: Date;
}

export interface PhaseRange {
  phase: string;
  start: number;
  end: number;
}

export function prepareChartData(cycleData: CycleData): ChartDataPoint[] {
  return cycleData.days.map(day => {
    return {
      day: day.day,
      date: format(day.absoluteDate, 'MMM d'),
      phase: day.phase,
      prediction: day.prediction,
      // Include all hormone values
      ...day.hormones,
      // Keep the original date object for formatting
      absoluteDate: day.absoluteDate
    };
  });
}

export function calculatePhaseRanges(chartData: ChartDataPoint[]): PhaseRange[] {
  const phaseRanges: PhaseRange[] = [];
  let currentPhase = chartData[0].phase;
  let startDay = chartData[0].day;
  
  for (let i = 1; i < chartData.length; i++) {
    if (chartData[i].phase !== currentPhase) {
      phaseRanges.push({
        phase: currentPhase,
        start: startDay,
        end: chartData[i-1].day
      });
      currentPhase = chartData[i].phase;
      startDay = chartData[i].day;
    }
  }
  
  // Add the last phase
  phaseRanges.push({
    phase: currentPhase,
    start: startDay,
    end: chartData[chartData.length-1].day
  });
  
  return phaseRanges;
}

export function findTodayPosition(cycleData: CycleData): number | null {
  const today = new Date();
  const todayPosition = cycleData.days.findIndex(day => 
    day.absoluteDate.getDate() === today.getDate() && 
    day.absoluteDate.getMonth() === today.getMonth() && 
    day.absoluteDate.getFullYear() === today.getFullYear()
  );
  
  return todayPosition !== -1 ? cycleData.days[todayPosition].day : null;
}
